import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { hexToMatrix } from '../../utils/hexToMatrixConverter';

const Leaf = (props) => {
  const theme = useTheme();
  const { variant, hideOnMobile, className } = props;

  const logoColor = variant === 'white'
    ? {
      fillColor: hexToMatrix(theme.colors.white).join(' '),
      textColor: theme.colors.white,
    }
    : {
      fillColor: hexToMatrix(theme.colors.red1).join(' '),
      textColor: theme.colors.red1,
    };

  const LeafSvg = styled.svg`
    ${(props) => props
      && props.hideOnMobile
      && `${theme.mq.untilMega} {
        display: none;
      }`}
  `;

  return (
    <LeafSvg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="56"
      height="54"
      viewBox="0 0 56 54"
      hideOnMobile={hideOnMobile}
      className={className}
    >
      <defs>
        <filter id="e8z4u3lbna">
          <feColorMatrix
            colorInterpolationFilters="sRGB"
            in="SourceGraphic"
            type="matrix"
          />
        </filter>
        <path id="v0y4mq13cb" d="M0 0L54.857 0 54.857 53.143 0 53.143z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  fill={logoColor.textColor}
                  d="M8.84 38.012l5.716 4.564 27.808-2.058 6.043-4.312.252-11.563H37.162l-5.018-2.97-2.137-6.756c-2.31-.541-3.465-.541-3.465 0 0 .542-2.685 2.433-8.054 5.675L4.452 21.674l2.157 3.778 2.231 8.204v4.356z"
                  transform="translate(-120 -1906) translate(0 1731) translate(1) translate(119.571 175.286)"
                />
                <g
                  filter="url(#e8z4u3lbna)"
                  transform="translate(-120 -1906) translate(0 1731) translate(1) translate(119.571 175.286)"
                >
                  <mask id="oq7fno1vrc" fill="#fff">
                    <use xlinkHref="#v0y4mq13cb" />
                  </mask>
                  <path
                    fill={logoColor.textColor}
                    d="M48.21 39.629h-.092v-.241c.021-.006.058-.01.109-.01.124 0 .18.05.18.128 0 .087-.088.123-.197.123m.233.062v-.01c.103-.03.175-.104.175-.196 0-.082-.037-.15-.083-.186-.062-.036-.133-.062-.293-.062-.14 0-.247.011-.324.026v.846h.195v-.34h.093c.108 0 .16.04.175.134.026.098.04.175.067.206h.21c-.02-.03-.035-.083-.062-.212-.025-.113-.071-.175-.153-.206m-.191.652c-.38 0-.658-.299-.658-.675 0-.37.277-.676.652-.676.377 0 .649.305.649.682 0 .37-.272.67-.643.67m-.006-1.526c-.482 0-.868.376-.868.845 0 .48.386.855.868.855.489 0 .865-.376.865-.855 0-.47-.376-.845-.865-.845m-25.94-10.585c-.094.015-.188.023-.28.023-.865 0-1.54-.641-1.605-1.525-.072-.981.652-1.907 1.613-2.065.094-.015.188-.023.281-.023.864 0 1.539.642 1.604 1.525.072.981-.652 1.907-1.613 2.065m32.342 2.614c-1.67-.55-6.37-2.863-2.264-10.739.069-.131.032-.268-.054-.355-.087-.086-.223-.122-.355-.054-7.868 4.11-10.179-.594-10.73-2.266-.073-.225-.365-.283-.516-.1l-4.548 5.984 1.16-16.819c.023-.236-.224-.402-.435-.294-1.571.792-6.528 2.483-9.188-5.992C27.673.071 27.55 0 27.428 0c-.122 0-.244.07-.289.212-2.66 8.475-7.617 6.784-9.187 5.992-.212-.108-.46.058-.437.294l.973 14.094c2.963-.187 6.132-.344 8.985-.399.642-.012.888.005 1.103.47.199.433.225.425.43.918.205.496-.137.74-.592.759-3.267.135-6.435.362-9.533.588-1.319 2.996-6.775 15.852-7.29 17.016-.019.041-.038.08-.059.117l4.013 3.055-4.169 4.128c-.18.178-.054.484.199.484h7.41v3.17c0 .077.114.264.328.229 1.586-.26 5.188-.852 7.874 1.929.043.044.13.087.242.087.105 0 .198-.043.24-.087 2.687-2.78 6.289-2.19 7.874-1.93.215.036.328-.151.328-.228v-3.17h7.411c.253 0 .379-.306.2-.484l-4.17-4.128 3.494-2.66c-.807-.116-1.461-.446-1.821-1.08-.235-.412-.298-.91.073-1.397.171-.224.39-.416.489-.491.144-.111.263-.162.364-.156.275.015.347.163.437.735.11.698.526 1.123 1.104 1.112.198-.004.903-.059 1.116-.778.155-.521.01-1.155-.409-1.921-.539-.989-.784-1.818-.749-2.617-.499.587-1.006 1.242-1.482 1.864-1.979 2.584-3.725 5.133-5.923 4.753-1.765-.305-1.557-1.996-1.51-2.331.142-1 .56-2.317 1.298-4.026-1.955 1.95-4.366 5.056-4.78 5.555-.43.516-.918.281-1.091.177l-.74-.474c-.494-.334-.633-.537-.47-1.14.368-1.354 1.147-3.487 1.67-4.894-2.282 2.191-5.178 5.778-5.716 6.426-.403.487-.862.295-1.162.108-.291-.183-.386-.25-.59-.382-.45-.292-.581-.489-.355-1.249.201-.673.575-1.733.93-2.662-1.831 2.614-3.192 3.788-4.167 4.256-.438.21-1.229.407-1.92.25-.919-.208-1.61-.925-1.354-2.547.34-2.154 2.21-6.081 2.946-7.635.307-.65.639-.827 1.19-.486.37.23.655.405.964.628.492.356.6.564.252 1.294-.91 1.911-1.794 3.906-2.247 5.157-.126.349-.405 1.213-.09 1.517.084.082.26.17.63.045.858-.291 3.018-2.798 5.672-7.326.178-.29.314-.524.404-.667.24-.385.472-.639 1.081-.264.336.206.653.409 1.006.668.47.345.422.63.15 1.223-.286.626-1.097 2.523-2.026 4.74 1.896-2.178 4.692-4.991 5.652-5.871.272-.25.59-.34.983-.087.444.285.72.468.977.644.37.255.445.443.153 1.118-.34.782-.844 1.886-1.772 4.428 1.56-1.874 3.662-4.067 5.093-5.397.41-.38.781-.516 1.31-.166.267.176.347.246.741.524.463.325.639.534.23 1.301-.544 1.018-1.263 2.432-1.83 4.303-.133.437-.487 1.396-.002 1.517.451.113 1.586-1.139 3.055-3.074 1.285-1.693 2.426-3.056 3.8-4.387.37-.36.914-.855 1.278-1.143.277-.22.589-.418.83-.436.172-.012.275.032.478.226.164.155.193.185.302.292.222.218.339.312.352.482.022.282-.115.362-.43.62l-.15.126c-.654.554-1.392 1.282-.89 2.376.166.365.656 1.273.881 1.954.183.552.227.974.226 1.285l7.501-5.712c.183-.151.126-.443-.1-.517m-39.112-7.67c-2.67.282-6.163.615-6.914.723-.953.137-1.04-.202-1.259-.762-.177-.453-.127-.275-.222-.555-.176-.515-.346-1.035.619-1.137 1.157-.122 4.702-.445 8.935-.736l-2.567-3.377c-.151-.183-.443-.125-.517.1-.55 1.672-2.861 6.376-10.73 2.266-.13-.068-.267-.032-.354.054-.086.087-.123.224-.054.355C6.579 27.984 1.88 30.297.209 30.847c-.226.074-.283.366-.1.517l8.731 6.648c1.653-3.61 2.712-6.255 3.62-8.24 1.6-3.493 2.38-5.104 3.076-6.595"
                    mask="url(#oq7fno1vrc)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </LeafSvg>
  );
};

Leaf.propTypes = {
  fillColors: PropTypes.string.isRequired,
  className: PropTypes.string,
};
Leaf.defaultProps = {
  fillColors: 'white',
};
export default Leaf;
